import { useEffect, useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import classes from './Pagination.module.scss';

export default function Pagination({
  href,
  setLoadedDataPages,
  currentPage,
  activePage,
  lastPage,
  postsPerPage,
  totalPosts,
  paginate,
  getPrevPage,
  getNextPage,
  getFirstPage,
  getLastPage,
}) {
  const pageNumbers = [];

  for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i += 1) {
    pageNumbers.push(i);
  }

  const paginationNumbersRef = useRef();

  const navigate = useNavigate();

  const [hash, setHash] = useState(currentPage);

  useEffect(() => {
    if (paginationNumbersRef && hash) {
      if (setLoadedDataPages) {
        setLoadedDataPages([]);
      }
      hash === 1 ? navigate(`/${href}`) : navigate(`/${href}?page=${hash}`);
      const el = paginationNumbersRef.current.children[hash - 1];
      el?.scrollIntoView();
    }
    window.scrollTo(0, 0);
  }, [hash]);

  // в пагинации прокрутываем до активной страницы (нужно при "показать еще")
  useEffect(() => {
    const el = paginationNumbersRef.current.children[activePage - 1];
    el?.scrollIntoView();
  }, [activePage]);

  const handleSwitchPage = value => {
    const { children } = paginationNumbersRef.current;
    let el = '';
    switch (value) {
      case 'next':
        [el] = [children[currentPage]];
        el.scrollIntoView();
        getNextPage();
        setHash(currentPage + 1);
        break;
      case 'prev':
        [el] = [children[currentPage - 2]];
        el.scrollIntoView();
        getPrevPage();
        setHash(currentPage - 1);
        break;
      case 'last':
        [el] = [children[lastPage - 1]];
        el.scrollIntoView();
        getLastPage();
        setHash(lastPage);
        break;
      default:
        [el] = [children[0]];
        el.scrollIntoView();
        getFirstPage();
        setHash(1);
        break;
    }
  };

  const handleChangeNumberPage = number => {
    paginate(number);
    if (setLoadedDataPages) {
      setLoadedDataPages([]);
    }
  };

  return (
    <div className={classes.pagination}>
      <button
        type='button'
        className={classes.paginationItemNavigation}
        onClick={() => handleSwitchPage()}
        disabled={currentPage === 1}
        aria-label='Первая страница'
      >
        <svg width='13' height='14' viewBox='0 0 13 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            // eslint-disable-next-line max-len
            d='M7.11366 1.28033C7.40656 0.987437 7.40656 0.512563 7.11366 0.21967C6.82077 -0.0732233 6.3459 -0.0732233 6.053 0.21967L0.21967 6.053C-0.0732233 6.3459 -0.0732233 6.82077 0.21967 7.11366L6.053 12.947C6.3459 13.2399 6.82077 13.2399 7.11366 12.947C7.40656 12.6541 7.40656 12.1792 7.11366 11.8863L1.81066 6.58333L7.11366 1.28033ZM12.1137 1.28033C12.4066 0.987437 12.4066 0.512563 12.1137 0.21967C11.8208 -0.0732233 11.3459 -0.0732233 11.053 0.21967L5.21967 6.053C4.92678 6.3459 4.92678 6.82077 5.21967 7.11366L11.053 12.947C11.3459 13.2399 11.8208 13.2399 12.1137 12.947C12.4066 12.6541 12.4066 12.1792 12.1137 11.8863L6.81066 6.58333L12.1137 1.28033Z'
            fill='currentColor'
          />
        </svg>
      </button>
      <button
        type='button'
        className={classes.paginationItemNavigation}
        onClick={() => handleSwitchPage('prev')}
        disabled={currentPage === 1}
        aria-label='Предыдущая страница'
      >
        <svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            // eslint-disable-next-line max-len
            d='M7.53017 0.636235C7.82306 0.929128 7.82306 1.404 7.53017 1.6969L2.22716 6.9999L7.53017 12.3029C7.82306 12.5958 7.82306 13.0707 7.53017 13.3636C7.23727 13.6565 6.7624 13.6565 6.46951 13.3636L0.636174 7.53023C0.343281 7.23734 0.343281 6.76246 0.636174 6.46957L6.46951 0.636235C6.7624 0.343342 7.23727 0.343342 7.53017 0.636235Z'
            fill='currentColor'
          />
        </svg>
      </button>
      <div
        className={
          pageNumbers?.length <= 4
            ? `${classes.paginationNumbers} ${classes.paginationNumbersSpaceAround}`
            : classes.paginationNumbers
        }
        ref={paginationNumbersRef}
      >
        {pageNumbers.map(number => (
          <Link
            key={number}
            to={number === 1 ? `${window.location.pathname}` : `${window.location.pathname}?page=${number}`}
            id={number}
            className={`${classes.paginationItem} ${activePage === number ? classes.paginationItemActive : ''}`}
            onClick={() => handleChangeNumberPage(number)}
          >
            {number}
          </Link>
        ))}
      </div>
      <button
        type='button'
        className={classes.paginationItemNavigation}
        onClick={() => handleSwitchPage('next')}
        disabled={activePage === lastPage}
        aria-label='Следующая страница'
      >
        <svg width='8' height='14' viewBox='0 0 8 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            // eslint-disable-next-line max-len
            d='M0.636328 13.3635C0.343434 13.0706 0.343434 12.5957 0.636328 12.3028L5.93933 6.99984L0.636327 1.69683C0.343433 1.40394 0.343433 0.929067 0.636327 0.636173C0.92922 0.343281 1.40409 0.343281 1.69699 0.636173L7.53032 6.46951C7.82321 6.7624 7.82321 7.23727 7.53032 7.53017L1.69699 13.3635C1.40409 13.6564 0.929221 13.6564 0.636328 13.3635Z'
            fill='currentColor'
          />
        </svg>
      </button>
      <button
        type='button'
        className={classes.paginationItemNavigation}
        onClick={() => handleSwitchPage('last')}
        disabled={activePage === lastPage}
        aria-label='Последняя страница'
      >
        <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
          <path
            fillRule='evenodd'
            clipRule='evenodd'
            // eslint-disable-next-line max-len
            d='M1.21821 11.8864C0.925312 12.1793 0.925312 12.6542 1.21821 12.9471C1.5111 13.24 1.98597 13.24 2.27887 12.9471L8.1122 7.11373C8.40509 6.82083 8.40509 6.34596 8.1122 6.05307L2.27887 0.21973C1.98597 -0.0731621 1.5111 -0.0731621 1.21821 0.21973C0.925313 0.512624 0.925313 0.987497 1.21821 1.28039L6.52121 6.5834L1.21821 11.8864ZM6.2182 11.8864C5.92531 12.1793 5.92531 12.6542 6.2182 12.9471C6.5111 13.24 6.98597 13.24 7.27887 12.9471L13.1122 7.11373C13.4051 6.82083 13.4051 6.34596 13.1122 6.05307L7.27887 0.21973C6.98597 -0.0731621 6.5111 -0.0731621 6.21821 0.21973C5.92531 0.512624 5.92531 0.987497 6.21821 1.28039L11.5212 6.5834L6.2182 11.8864Z'
            fill='currentColor'
          />
        </svg>
      </button>
    </div>
  );
}
